import React, { useEffect } from 'react';
import classNames from 'classnames';
import { analyticsService } from '@common/analytics';
import Input, { LOGIN_EMAIL, LOGIN_PASSWORD } from './input';
import classes from '../classes.module.scss';
import { passwordIsValid } from '../../../config/util';
import { emailIsValid } from '../../../../common/config/utils';
import Const from '../../../config/const';
import { useNotification } from '../../firebase_messaging_provider';

const allFieldsValid = (email, password) => emailIsValid(email) && passwordIsValid(password, true);

function LogIn({
  email,
  password,
  loading,
  error,
  t,
  onFieldChanged,
  rememberMe,
  social,
  changeScreen,
  onLogin,
  checkInputErrors,
  clearError
}) {
  const { requestPermission } = useNotification();

  useEffect(() => {
    analyticsService.trackPageVisit('log in with email');
  }, []);

  const navigate = (e) => {
    changeScreen(e.target.id);
    clearError();
  };

  const onLoginClick = () => {
    checkInputErrors();
    if (allFieldsValid(email, password)) {
      requestPermission(true);
      onLogin();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onLoginClick();
    }
  };

  return (
    <div>
      <div>
        <Input
          inputType={ LOGIN_EMAIL }
          onKeyDown={ handleKeyPress }
          onChange={ onFieldChanged }
          value={ email }
          id="email"
          disabled={ loading }
          error={ error && error.email && error.email[0] }
        />
      </div>
      <div>
        <Input
          inputType={ LOGIN_PASSWORD }
          onKeyDown={ handleKeyPress }
          onChange={ onFieldChanged }
          value={ password }
          id="password"
          disabled={ loading }
          error={ error && error.password && error.password[0] }
        />
      </div>
      { rememberMe }
      <div>
        <button
          data-testid="login-button"
          className={ classNames(
            classes.actionButton,
            !loading ? null : classes.disableActionBtn
          ) }
          type="button"
          onClick={ onLoginClick }
        >
          <b>{t('login')}</b>
        </button>
      </div>
      <div className={ classes.navigationButtonContainer }>
        <button
          data-testid="forgot-password-button"
          id={ Const.authScreens.forgotPassword }
          className={ classes.navigationButton }
          type="button"
          onClick={ navigate }
        >
          {t('forgot_password')}
        </button>
      </div>
      <div>{social}</div>
      <div className={ classes.navigationButtonContainer }>
        <button
          data-testid="sign-up-button"
          id={ Const.authScreens.signUp }
          className={ classes.navigationButton }
          type="button"
          onClick={ navigate }
        >
          {t('not_have_account')}
        </button>
      </div>
    </div>
  );
}

export default LogIn;
